import useStore from '../../store/useStore';

/**
 * Floating dark/light mode toggle — top-right corner.
 * Lets you test the glow without scrolling.
 */
export default function DarkModeToggle() {
    const isDark = useStore((s) => s.isDark);
    const { toggleDark } = useStore.getState().methods;

    return (
        <button
            type="button"
            onClick={toggleDark}
            className={[
                'fixed top-5 right-5 z-50 rounded-full px-4 py-2 text-xs tracking-widest uppercase',
                'border transition-all duration-500',
                isDark
                    ? 'border-[var(--glow-color)] text-[var(--glow-color)] bg-black/60'
                    : 'border-[var(--fg-muted)] text-[var(--fg-muted)] bg-white/60',
            ].join(' ')}
            style={isDark ? { boxShadow: '0 0 12px var(--glow-color)' } : {}}
        >
            {isDark ? '◑ Light' : '◐ Dark'}
        </button>
    );
}
